import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import {
  useStopLogisticTasksMutation
} from "../../../../entities/logistic/logisticTasks/redux/logisticTasks.api";

const useStopLongPulling = ({ onSuccess }) => {
  const { logisticTaskId } = useParams();

  const [stopLogisticTasks, {
    isLoading,
    isFetching, data: { status = null } = {}
  }] = useStopLogisticTasksMutation();

  const isStopping = isLoading || isFetching || status === "STOPPING";

  const handleClick = () => {
    if (!isStopping) {
      stopLogisticTasks({ id: logisticTaskId }).then(() => onSuccess());
    } else {
      toast.error("Пожалуйста, подождите завершения запроса.");
    }
  };

  return { handleClick, isStopping };
};

export default useStopLongPulling;
